import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';
import { type CarrierFormField } from '~/types/CarrierFormField';

export type CarrierFormFieldsState = {
  readonly carrierFormFieldValidations: { [key: string]: ((data: string) => void)[] }; // Object contains keys to Array<func>
  readonly carrierFormFields: readonly CarrierFormField[];
  readonly errorMessage: string;
  readonly isFetchingCarrierFormFields: boolean;
};

const initialState: CarrierFormFieldsState = {
  carrierFormFieldValidations: {},
  carrierFormFields: [],
  errorMessage: '',
  isFetchingCarrierFormFields: false,
};

const carrierFormFieldsReducer = (
  state: CarrierFormFieldsState = initialState,
  action: ActionTypes,
): CarrierFormFieldsState => {
  switch (action.type) {
    case ActionKeys.CARRIER_FORM_FIELDS_CLEAR_STATE:
      return {
        ...state,
        carrierFormFieldValidations: {},
        carrierFormFields: [],
        errorMessage: '',
      };
    case ActionKeys.FETCH_CARRIER_FORM_FIELDS:
      return {
        ...state,
        isFetchingCarrierFormFields: true,
      };
    case ActionKeys.FETCH_CARRIER_FORM_FIELDS_SUCCESS:
      return {
        ...state,
        carrierFormFieldValidations: action.payload.carrierFormFieldValidations,
        carrierFormFields: action.payload.carrierFormFields,
        isFetchingCarrierFormFields: false,
      };
    case ActionKeys.FETCH_CARRIER_FORM_FIELDS_ERROR:
      return {
        ...state,
        errorMessage: action.payload.error,
        isFetchingCarrierFormFields: false,
      };
    default:
      return state;
  }
};

export default carrierFormFieldsReducer;
